import Image from "next/image";
import React, { useState } from "react";
import ModalVideo from "react-modal-video";

const FounderWelcome = () => {
  const [videoModal1, setvideoModal1] = useState(false);
  const [videoModal2, setvideoModal2] = useState(false);

  const [url1, setUrl1] = useState(null);
  const [url2, setUrl2] = useState(null);

  return (
    <>
      {/* <!-- FounderWelcome --> */}
      <section className="relative py-16 dark:bg-jacarta-800">
        <picture className="pointer-events-none absolute inset-0 -z-10 dark:hidden !ml-0">
          <Image
            width={1519}
            height={773}
            priority
            src="/images/gradient_light.jpg"
            alt="gradient"
            className="h-full w-full object-cover"
          />
        </picture>
        <div className="container">
          <div className="mx-auto max-w-2xl mb-4 text-center">
            <h1 className="font-display text-3xl text-jacarta-700 dark:text-white lg:text-4xl xl:text-6xl text-center uppercase">
              Meet the Founders
            </h1>
          </div>
          <div className="lg:flex lg:justify-between">
            {/* <!-- Image --> */}
            <div className="relative lg:w-[55%]">
              <Image
                width={68}
                height={68}
                src="/images/patterns/pattern_circle_1.png"
                className="absolute -bottom-4 -left-8 animate-fly dark:opacity-10"
                alt="circle"
              />
              {/* <Image
                width={143}
                height={143}
                src="/images/patterns/pattern_circle_2.png"
                className="absolute -top-14 right-0 animate-fly dark:opacity-10 md:-right-12"
                alt="circle"
              /> */}
              <div className="flex items-center space-x-7">
                {/* <figure className="relative">
                  <Image
                    width={308}
                    height={452}
                    src="/images/crypto-consultant/promo_1.jpg"
                    className="rounded-3xl w-full h-full object-cover"
                    alt="promo"
                  />
                </figure> */}
                <figure className="relative overflow-hidden rounded-3xl before:absolute before:inset-0 before:bg-jacarta-900/25">
                  <button
                    onClick={() => {
                      setvideoModal1(true);
                      setUrl1("https://www.youtube.com/embed/75trDtX8gyI");
                    }}
                    className="js-video-modal-trigger absolute top-1/2 left-1/2 flex h-16 w-16 -translate-y-1/2 -translate-x-1/2 items-center justify-center rounded-full border-2 border-white transition-transform will-change-transform hover:scale-90"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                      className="h-8 w-8 fill-white"
                    >
                      <path fill="none" d="M0 0h24v24H0z" />
                      <path d="M19.376 12.416L8.777 19.482A.5.5 0 0 1 8 19.066V4.934a.5.5 0 0 1 .777-.416l10.599 7.066a.5.5 0 0 1 0 .832z" />
                    </svg>
                  </button>
                  <Image
                    width={308}
                    height={471}
                    src="/images/about/founder_1.png"
                    className="w-full h-full object-cover"
                    alt="img"
                  />
                </figure>
                <figure className="relative overflow-hidden rounded-3xl before:absolute before:inset-0 before:bg-jacarta-900/25">
                  <button
                    onClick={() => {
                      setvideoModal2(true);
                      setUrl2("https://www.youtube.com/embed/IZBoavzdLFc");
                    }}
                    className="js-video-modal-trigger absolute top-1/2 left-1/2 flex h-16 w-16 -translate-y-1/2 -translate-x-1/2 items-center justify-center rounded-full border-2 border-white transition-transform will-change-transform hover:scale-90"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="24"
                      height="24"
                      className="h-8 w-8 fill-white"
                    >
                      <path fill="none" d="M0 0h24v24H0z" />
                      <path d="M19.376 12.416L8.777 19.482A.5.5 0 0 1 8 19.066V4.934a.5.5 0 0 1 .777-.416l10.599 7.066a.5.5 0 0 1 0 .832z" />
                    </svg>
                  </button>
                  <Image
                    width={308}
                    height={471}
                    src="/images/about/founder_2.png"
                    className="w-full h-full object-cover"
                    alt="img"
                  />
                </figure>
              </div>
            </div>

            {/* <!-- Info --> */}

            <div className="py-10 lg:w-[45%] lg:pl-28">
              <p className="mb-8 text-lg dark:text-jacarta-300">
                Noleen Mariappen and Kala Philo met in a 2016 Houston
                accelerator program. After staying in touch, they joined forces
                in 2022 to bring Impactoverse to life.
              </p>
              <div className="mb-8 flex space-x-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                  className="h-8 w-8 shrink-0 fill-accent"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-.997-4L6.76 11.757l1.414-1.414 2.829 2.829 5.656-5.657 1.415 1.414L11.003 16z" />
                </svg>
                <div>
                  <span className="mb-3 block font-display text-base font-semibold text-jacarta-700 dark:text-white">
                    Tech-Driven Visionaries
                  </span>
                  <span className="mt-10 mb-5 dark:text-jacarta-300">
                    Noleen Mariappen and Kala Philo founded Impactoverse to
                    leverage technology for scalable impact.
                  </span>
                </div>
              </div>
              <div className="flex space-x-4">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                  className="h-8 w-8 shrink-0 fill-accent"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path d="M12 22C6.477 22 2 17.523 2 12S6.477 2 12 2s10 4.477 10 10-4.477 10-10 10zm0-2a8 8 0 1 0 0-16 8 8 0 0 0 0 16zm-.997-4L6.76 11.757l1.414-1.414 2.829 2.829 5.656-5.657 1.415 1.414L11.003 16z" />
                </svg>
                <div>
                  <span className="mb-3 block font-display text-base font-semibold text-jacarta-700 dark:text-white">
                    Insights and Journey
                  </span>
                  <span className="mt-10 mb-5 dark:text-jacarta-300">
                    Watch their videos for a deep dive into the story and
                    passions that fuel Impactoverse.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* <!-- end promo --> */}

      {/* <!-- YouTube Video Modal --> */}
      <div
        className={
          videoModal1 ? "modal lightbox fade show block" : "modal lightbox fade"
        }
      >
        <div className="modal-dialog modal-dialog-centered modal-xl w-full">
          <div className="modal-content border-0 bg-transparent">
            <div className="modal-body p-0 relative">
              <button
                onClick={() => {
                  setvideoModal1(false);
                  setUrl1(null);
                }}
                type="button"
                className="btn-close position-absolute top-0 end-0 p-3 z-10"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 16 16"
                  fill="#fff"
                  className="h-6 w-6"
                >
                  <path d="M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z"></path>
                </svg>
              </button>
              <div
                id="lightboxCarousel-d7ewe4ig"
                className="lightbox-carousel carousel"
              >
                <div className="carousel-inner">
                  <div className="carousel-item active">
                    <div className="position-absolute top-50 start-50 translate-middle text-white">
                      <div className="spinner-border" role="status"></div>
                    </div>
                    <div className="ratio ratio-16x9">
                      <iframe
                        src={url1}
                        title="YouTube video player"
                        allow="accelerometer clipboard-write encrypted-media gyroscope picture-in-picture autoplay"
                      ></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div
        className={
          videoModal2 ? "modal lightbox fade show block" : "modal lightbox fade"
        }
      >
        <div className="modal-dialog modal-dialog-centered modal-xl w-full">
          <div className="modal-content border-0 bg-transparent">
            <div className="modal-body p-0 relative">
              <button
                onClick={() => {
                  setvideoModal2(false);
                  setUrl2(null);
                }}
                type="button"
                className="btn-close position-absolute top-0 end-0 p-3 z-10"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 16 16"
                  fill="#fff"
                  className="h-6 w-6"
                >
                  <path d="M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z"></path>
                </svg>
              </button>
              <div
                id="lightboxCarousel-d7ewe4ig"
                className="lightbox-carousel carousel"
              >
                <div className="carousel-inner">
                  <div className="carousel-item active">
                    <div className="position-absolute top-50 start-50 translate-middle text-white">
                      <div className="spinner-border" role="status"></div>
                    </div>
                    <div className="ratio ratio-16x9">
                      <iframe
                        src={url2}
                        title="YouTube video player"
                        allow="accelerometer clipboard-write encrypted-media gyroscope picture-in-picture autoplay"
                      ></iframe>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FounderWelcome;
